var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_273_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 34C20 26.268 26.268 20 34 20H130C137.732 20 144 26.268 144 34V130C144 137.732 137.732 144 130 144H34C26.268 144 20 137.732 20 130V34Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1667 44.5H48.6667C46.3655 44.5 44.5 46.3655 44.5 48.6667V61.1667C44.5 63.4679 46.3655 65.3333 48.6667 65.3333H61.1667C63.4679 65.3333 65.3333 63.4679 65.3333 61.1667V48.6667C65.3333 46.3655 63.4679 44.5 61.1667 44.5Z",
    stroke: "black",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 44.5H102.833C100.532 44.5 98.6666 46.3655 98.6666 48.6667V61.1667C98.6666 63.4679 100.532 65.3333 102.833 65.3333H115.333C117.634 65.3333 119.5 63.4679 119.5 61.1667V48.6667C119.5 46.3655 117.634 44.5 115.333 44.5Z",
    stroke: "black",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1667 98.6667H48.6667C46.3655 98.6667 44.5 100.532 44.5 102.833V115.333C44.5 117.635 46.3655 119.5 48.6667 119.5H61.1667C63.4679 119.5 65.3333 117.635 65.3333 115.333V102.833C65.3333 100.532 63.4679 98.6667 61.1667 98.6667Z",
    stroke: "black",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.5 98.6667H107C104.79 98.6667 102.67 99.5447 101.107 101.108C99.5446 102.67 98.6666 104.79 98.6666 107V119.5",
    stroke: "black",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.5 119.5V119.542",
    stroke: "black",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 61.1667V73.6667C82 75.8769 81.122 77.9965 79.5592 79.5593C77.9964 81.1221 75.8768 82.0001 73.6666 82.0001H61.1666",
    stroke: "black",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 82H44.5417",
    stroke: "black",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 44.5H82.0417",
    stroke: "black",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 98.6667V98.7084",
    stroke: "black",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6666 82H102.833",
    stroke: "black",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.5 82V82.0417",
    stroke: "black",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 119.5V115.333",
    stroke: "black",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_273_82",
    x: 0,
    y: 0,
    width: 164,
    height: 164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_273_82"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_273_82",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.7f11da7697eab8542af123586db92c3a.svg";
export { ForwardRef as ReactComponent };